import { render, staticRenderFns } from "./LogisticsManageDialog.vue?vue&type=template&id=a86fd68c&"
import script from "./LogisticsManageDialog.vue?vue&type=script&lang=ts&"
export * from "./LogisticsManageDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports